(() => {
  if (customElements.get("promo-carousel")) return;

  class PromoCarousel extends HTMLElement {
    constructor() {
      super();
      this.cleanup = [];
      this.editorCleanup = null;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll("[data-slide]"));
      this.dots = Array.from(this.querySelectorAll("[data-dot]"));
      this.prevButton = this.querySelector("[data-slider-prev]");
      this.nextButton = this.querySelector("[data-slider-next]");

      if (!this.slides.length) {
        return;
      }

      this.currentIndex = 0;
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onDotClick = this.onDotClick.bind(this);

      this.updateSlides();

      this.addListener(this.prevButton, "click", this.onPrev);
      this.addListener(this.nextButton, "click", this.onNext);
      this.dots.forEach((dot) => this.addListener(dot, "click", this.onDotClick));
      this.bindEditorBlocks();
    }

    disconnectedCallback() {
      this.cleanup.forEach((remove) => remove());
      this.cleanup = [];
      if (this.editorCleanup) {
        this.editorCleanup();
        this.editorCleanup = null;
      }
    }

    addListener(el, event, handler, options) {
      if (!el) return;
      el.addEventListener(event, handler, options);
      this.cleanup.push(() => el.removeEventListener(event, handler, options));
    }

    bindEditorBlocks() {
      if (!window.webvista || typeof window.webvista.bindShopifyEditorBlockEvents !== "function") {
        return;
      }

      this.editorCleanup = window.webvista.bindShopifyEditorBlockEvents({
        root: this,
        getBlockElement: (blockId) =>
          this.querySelector(`[data-slide][data-block-id="${blockId}"]`),
        onSelect: ({ blockId }) => {
          const slide = this.querySelector(
            `[data-slide][data-block-id="${blockId}"]`,
          );
          if (!slide) {
            return;
          }
          const index = Number.parseInt(slide.dataset.slide || "-1", 10);
          if (!Number.isFinite(index) || index < 0) {
            return;
          }
          this.goToSlide(index);
        },
        onDeselect: () => {},
      });
    }

    onPrev() {
      this.goToSlide(this.currentIndex - 1);
    }

    onNext() {
      this.goToSlide(this.currentIndex + 1);
    }

    onDotClick(event) {
      const index = Number.parseInt(event.currentTarget.dataset.dot || "0", 10);
      if (!Number.isFinite(index)) {
        return;
      }
      this.goToSlide(index);
    }

    goToSlide(index) {
      const total = this.slides.length;
      const nextIndex = ((index % total) + total) % total;
      if (nextIndex === this.currentIndex) {
        return;
      }
      this.currentIndex = nextIndex;
      this.updateSlides();
    }

    updateSlides() {
      this.slides.forEach((slide, index) => {
        const isActive = index === this.currentIndex;
        slide.classList.toggle("is-active", isActive);
        slide.setAttribute("aria-hidden", isActive ? "false" : "true");
      });

      this.dots.forEach((dot, index) => {
        const isActive = index === this.currentIndex;
        dot.classList.toggle("is-active", isActive);
        dot.setAttribute("aria-current", isActive ? "true" : "false");
      });
    }
  }

  customElements.define("promo-carousel", PromoCarousel);
})();